/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplyFixedWingLineActionRequest } from '../../models/apply-fixed-wing-line-action-request';
import { FixedWingLineResponse } from '../../models/fixed-wing-line-response';

export interface ApplyFixedWingLineAction$Params {
  id: number;
      body: ApplyFixedWingLineActionRequest
}

export function applyFixedWingLineAction(http: HttpClient, rootUrl: string, params: ApplyFixedWingLineAction$Params, context?: HttpContext): Observable<StrictHttpResponse<FixedWingLineResponse>> {
  const rb = new RequestBuilder(rootUrl, applyFixedWingLineAction.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FixedWingLineResponse>;
    })
  );
}

applyFixedWingLineAction.PATH = '/api/scheduler/daily-line-schedule/fixed-wing/lines/{id}/actions';
